import { css } from 'styled-components';
import { innerBorder } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

export const typeInProgress = css`
  &.in-progress,
  &.in_progress {
    color: ${colorsV2.red100};
    ${innerBorder(`2px solid ${colorsV2.red80}`)}

    &:hover {
      background: ${colorsV2.red10};
      outline: 2px solid ${colorsV2.red20};
    }

    &.selected {
      background: ${colorsV2.red20};
      outline: 2px solid ${colorsV2.red20};
    }
  }
`;

export const typeCorrect = css`
  &.correct {
    color: ${colorsV2.green100};
    ${innerBorder(`2px solid ${colorsV2.green80}`)}

    &:hover {
      background: ${colorsV2.green10};
      outline: 2px solid ${colorsV2.green20};
    }

    &.selected {
      background: ${colorsV2.green20};
      outline: 2px solid ${colorsV2.green20};
    }
  }
`;

export const typeDefault = css`
  color: ${colorsV2.gray160};
  ${innerBorder(`2px solid ${colorsV2.gray80}`)}

  &:hover {
    background: ${colorsV2.gray20};
    outline: 2px solid ${colorsV2.gray40};
  }

  &.selected {
    background: ${colorsV2.gray40};
    outline: 2px solid ${colorsV2.gray40};
    ${innerBorder(`2px solid ${colorsV2.gray100}`)}
  }
`;

export const typeStyles = css`
  ${typeDefault}
  ${typeCorrect}
  ${typeInProgress}

  &.disabled {
    color: ${colorsV2.black20};
    ${innerBorder(`2px solid ${colorsV2.black10}`)}
    cursor: not-allowed;
  }
`;
